import { uuidv4 } from '@embed/helpers';
/**
 *
 */
export function generateId() {
    return `__${uuidv4()}`;
}
